import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Line } from '../dto/line';
import { ResultForRequest } from '../dto/result-for-request';
import { LineCatch } from '../dto/line-catch';
import { CatchitHttpService } from './catchit-http.service';

@Injectable({
  providedIn: 'root'
})
export class LineService {

  constructor(private http: CatchitHttpService) {}

  public getById(id: number): Observable<Line> {
    return this.http.get<Line>('/lines/' + id);
  }

  public getAll(): Observable<Line[]> {
    return this.http.get<Line[]>('/lines/');
  }

  public getLinesByAreaId(areaId: number): Observable<Line[]> {
    return this.http.get<Line[]>('/lines/area/' + areaId);
  }

  public getLinesByAreaIdAndPersonId(areaId: number, personId: number): Observable<Line[]> {
    return this.http.get<Line[]>('/lines/area/' + areaId + '/person/' + personId);
  }

  public getAllLinesByAreaId(areaId: number): Observable<Line[]> {
    // This search returns all lines in the area, even ones that are disabled
    return this.http.get<Line[]>('/lines/all/area/' + areaId);
  }

  public getAllLinesThatUserHasPermissionToAccess(personId: number): Observable<Line[]> {
    return this.http.get<Line[]>('/lines/all/person/' + personId);
  }

  public getAllCatchesOnTheLine(lineId: number): Observable<LineCatch[]> {
    return this.http.get<LineCatch[]>('/lines/' + lineId + '/catches');
  }

  public update(line: Line): Observable<ResultForRequest> {
    return this.http.put<ResultForRequest>('/lines/' + line.id, line);
  }

  public create(line: Line): Observable<ResultForRequest> {
    return this.http.post<ResultForRequest>('/lines/', line);
  }
}